const preprendDigit = (number) => ("0" + number).slice(-2);

export const getHours = (seconds) =>
  preprendDigit(Math.floor(seconds / 3600).toFixed(0));
const getMinutes = (seconds) =>
  preprendDigit(Math.floor((seconds % 3600) / 60).toFixed(0));
const getSeconds = (seconds) =>
  preprendDigit(((seconds % 3600) % 60).toFixed(0));

export default function formatSeconds(seconds) {
  return seconds
    ? `${getHours(seconds)}:${getMinutes(seconds)}:${getSeconds(seconds)}`
    : "--";
}

export function formatDurationHuman(seconds) {
  if (!seconds) return "";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h${String(minutes).padStart(2, "0")}`;
}
